import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  NgZone,
  OnDestroy,
  AfterViewInit,
} from "@angular/core";
import { AgmMap, ControlPosition, MapsAPILoader, MapTypeControlOptions, MouseEvent } from "@agm/core";
import { Events } from "src/app/utils/event-utils";
import { SocketService } from "src/app/service/socket-service/socket-service.service";
import { sweetAlert } from "../../../utils/swal";
import { ActivatedRoute } from "@angular/router";
import * as moment from "moment-timezone";
import { SharedDataService } from "src/app/service/shared-service/shared-data.service";
import { DispatchCenterService } from "../dashboard-service/dispatch-center-service";
import { AssigTripsService } from "../../assigned-trips/assigntrips-service/assigntrips-service";
import { mapStyles } from "src/app/utils/utils.common";
import { takeUntil } from "rxjs/operators";
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import { OfferedtripsService } from "../../offered-trips/offered-trips-service/offeredtrips.service";
import { ServiceAreasService } from "../../service-areas/service-areas-service/service-areas.service";
import * as _ from 'underscore';
import { DriversService } from "../../drivers/drivers-service/drivers-service";
import { StaffService } from "../../staffs/staff-service/staff.service";
import { CorporateService } from "../../corporate-user/corporate-service/corporate-service";



declare var $;

@Component({
  selector: "app-main",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"],
})
export class DispatchDashboardComponent implements OnInit, AfterViewInit, OnDestroy {
  duration = 5 * 1000; // 10 seconds
  // Map
  @ViewChild("AgmMap", { static: true }) agmElement: AgmMap;
  @ViewChild('timer', { static: true }) timer;

  mapTypeControlOptions: MapTypeControlOptions = {
    position: ControlPosition.TOP_LEFT
  };
  agmMap;
  trafficLayer: google.maps.TrafficLayer;
  origin = { lat: 0.0, lng: 0.0 };
  destination = { lat: 0.0, lng: 0.0 };
  latitude: number;
  longitude: number;
  zoom: number = 12;
  styles = mapStyles();
  driverSearch = "";
  notificationSearch = "";
  address: string;
  geoCoder;
  public tripModalObject: any;
  public assignModalObj: any;
  public driverTripModalObj: any;
  public driverTripModalObject: any;
  live = true;
  isFilter = false;

  public drivers = [];
  filteredDrivers = [];
  public approachingTrips = [];
  public expiringSoonTrips = [];
  public markedTrips = [];
  notifications = [];
  companyDriverStatus;
  tripId = null;
  reDispatchTripDetail;
  selectedDriver;
  public driverManifestTrips = [];
  public selectedDriverForManifest = null;
  public manifestPoints = [];
  public manifestRoute: any = null;
  public manifestSegments: any[] = [];

  bounds;
  tripsInProgress;
  tripsInProgressObserver;
  selectedApproachingTripOption;
  @ViewChild("search", { static: false })
  public searchElementRef: ElementRef;

  onlineDrivers = 0;
  busyDrivers = 0;
  offlineDrivers = 0;

  isInprogressRoutes = false;
  isMarkedReadyTrips = false;
  isMarkedReadyRoutes = false;
  isExpiredTrips = false;
  isExpiredTripRoutes = false;
  isTraffic = false;
  isApproachingTrips = false;
  isAutoZoom = true;
  openPopup = false;
  showCreateTripModal = true;
  showInprogressTripsSlideout = false;
  driverDetailProfileModal;
  isCTCTrips = false;
  public ctcTripsList = [];
  timeZone;
  showCTCTrips;
  ctcTime = 0;
  selectedMapDriver = '';

  serviceAreaList = [];
  selectedServiceArea: any[] = [];
  preServiceAreas = {};
  user;
  isRdispatcher = false;
  preDriverList = {};
  preStaffList: any = {};
  stationManagerList: any[] = [];
  selectedStationManagers: any[] = [];
  preCorporateUsers = {};
  fundingSourceList: any[] = [];
  selectedFundingSources: any[] = [];



  constructor(
    private dispatchCenterService: DispatchCenterService,
    private assignTripService: AssigTripsService,
    private socketService: SocketService,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private activatedRoute: ActivatedRoute,
    private offeredTripsService: OfferedtripsService,
    private sharedDataService: SharedDataService,
    private serviceArea: ServiceAreasService,
    private driverService: DriversService,
    private staffService: StaffService,
    private corporateService: CorporateService
  ) { }

  ngOnInit() {
    this.getStaffList();
    this.getCorporateUsers();
    this.listenSocketEvents();
    this.getServiceAreas();
  }


  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          if (this.user.sRoles && this.user.sRoles === 'rdispatcher') {
            this.selectedStationManagers = [this.user.sId];
            this.isRdispatcher = true;
          }
          // user.showCTCTrips = true;
          this.timeZone = user.timeZone;
          this.showCTCTrips = user.showCTCTrips;
          this.getNotificationsList();
          this.timer.start();
          this.emitSocketEvents();
          this.getDrivers();
          // this.getTripsInProgress();
        }
      });
  }

  getServiceAreas() {
    this.serviceArea.getServiceAreas({ status: 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preServiceAreas = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }


  ngAfterViewInit() {
    this.agmElement.mapReady
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((map) => {
        this.agmMap = map;
        this.geoCoder = new google.maps.Geocoder;
        this.getUser();
      });
  }
  onTimerComplete(): void {
    this.timer.init();
    this.emitSocketEvents();
    setTimeout(() => {
      this.timer.start();
    }, 1000);

    // this.getTripsInProgress();
    // this.ctcTime += 1;
    // if (this.ctcTime >= 60) { // 5 mins interval for the ctc call 300s / 5s interval = 60
    //   this.ctcTime = 0;
    //   this.fetchCtcTrips();
    // }
  }


  // Drivers Counts
  setDriverCounts() {
    this.onlineDrivers = 0;
    this.busyDrivers = 0;
    this.offlineDrivers = 0;

    this.drivers.forEach((driver) => {
      if (driver.status === "online") {
        this.onlineDrivers++;
      } else if (driver.status === "buzy") {
        this.busyDrivers++;
      } else if (driver.status === "offline") {
        this.offlineDrivers++;
      }
    });

  }

  getTripsInProgress() {

    // isShowAllTrips: false
    const object = {
      status: "inprogress",
      scheduleTime: moment().tz(this.timeZone).startOf('day').toISOString()
    };

    this.assignTripService
      .getAssignList(object)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data && data.length) {
          this.tripsInProgress = data;
        }
        this.timer.start();
      });

  }

  // Map Methods
  setBounds() {
    if (!this.isAutoZoom) return;

    if (this.agmMap) {
      let bounds = new google.maps.LatLngBounds();
      const markedReadyTrips = this.expiringSoonTrips.concat(this.markedTrips);

      for (const driver of this.drivers) {
        bounds.extend(
          new window["google"].maps.LatLng(
            driver.latitude ? driver.latitude : 0,
            driver.longitude ? driver.longitude : 0
          )
        );
      }

      for (const trip of this.ctcTripsList) {
        bounds.extend(
          new window["google"].maps.LatLng(
            trip.PULatitude ? trip.PULatitude : 0,
            trip.PULongitude ? trip.PULongitude : 0
          )
        );
      }

      for (const trip of markedReadyTrips) {
        bounds.extend(
          new window["google"].maps.LatLng(
            trip.jobOriginLatitude,
            trip.jobOriginLongitude
          )
        );
      }

      for (const trip of this.driverManifestTrips) {
        if (trip.jobOriginLatitude && trip.jobOriginLongitude) {
          bounds.extend(new window["google"].maps.LatLng(trip.jobOriginLatitude, trip.jobOriginLongitude));
        }
        if (trip.jobDestinationLatitude && trip.jobDestinationLongitude) {
          bounds.extend(new window["google"].maps.LatLng(trip.jobDestinationLatitude, trip.jobDestinationLongitude));
        }
      }


      this.agmMap.setCenter(bounds.getCenter());
      this.agmMap.fitBounds(bounds);
    }
  }

  // Socket Events STARTS




  emitSocketEvents() {
    this.socketService.emit(Events.GET_COMPANY_DRIVER_STATUS);

    // Expired Trips
    if (this.isExpiredTrips) {
      this.socketService.emit(Events.SOON_EXPIRING_TRIPS);
    } else {
      this.expiringSoonTrips = [];
    }

    // Marked Ready Trips
    if (this.isMarkedReadyTrips) {
      this.socketService.emit(Events.GET_MARKED_TRIPS);
    } else {
      this.markedTrips = [];
    }
  }

  listenSocketEvents() {
    this.socketService
      .addListener(Events.GET_COMPANY_DRIVER_STATUS)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data.success && data.drivers && data.drivers.length) {
          this.setupDriverList(data.drivers);
        } else {
          this.drivers = [];
          this.filteredDrivers = [];
          this.serviceAreaList = [];
        }
      });

    this.socketService
      .addListener(Events.SOON_EXPIRING_TRIPS)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data.success) {
          if (this.isExpiredTrips) {
            this.expiringSoonTrips = data.assigns;
            // this.setBounds();
            this.setBounds();
          } else {
            this.expiringSoonTrips = [];
          }
        } else {
          this.expiringSoonTrips = [];
        }
      });

    this.socketService
      .addListener(Events.GET_MARKED_TRIPS)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data.success) {
          if (this.isMarkedReadyTrips) {
            this.markedTrips = data.assigns;
            // this.setBounds();
            this.setBounds()
          } else {
            this.markedTrips = [];
          }
        } else {
          this.markedTrips = [];
        }
      });

    this.socketService
      .addListener(Events.GET_APPROCHING_TRIPS)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data.success) {
          this.approachingTrips = [];
          this.approachingTrips.push(...data.assigns);
        } else {
          this.approachingTrips = [];
        }
      });

    this.socketService
      .addListener(Events.SEND_EXPIRE_DISPATCH)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data.sucess) {
          this.getNotificationsList();
        }
      });
  }

  setupDriverList(drivers: any[]) {
    this.stationManagerList = [];
    this.serviceAreaList = [];
    this.fundingSourceList = [];

    drivers.forEach(driver => {
      const driverFromApi = (this.preDriverList as any)[driver._id];

      if (driverFromApi && driverFromApi.stationManager) {
        driver.stationManager = driverFromApi.stationManager;
        if (this.preStaffList[driver.stationManager]) {
          this.stationManagerList.push(driver.stationManager);
        }
      } else {
        driver.stationManager = null;
      }

      if (driverFromApi && driverFromApi.fundingSources && driverFromApi.fundingSources.length) {
        driver.fundingSources = driverFromApi.fundingSources;
        (driverFromApi.fundingSources as any[]).forEach(fs => {
          if (fs.name && (this.preCorporateUsers as any)[fs.name]) {
            this.fundingSourceList.push(fs.name);
          }
        });
      }

      if (driver.serviceAreas && driver.serviceAreas.length) {
        (driver.serviceAreas as any[]).forEach(id => {
          if ((this.preServiceAreas as any)[id]) {
            this.serviceAreaList.push(id);
          }
        });
      }
    });

    this.drivers = drivers;
    this.filteredDrivers = drivers;

    if (this.serviceAreaList && this.serviceAreaList.length) {
      this.serviceAreaList = (_.uniq(this.serviceAreaList) as any[]).map(id => ({
        _id: id,
        name: (this.preServiceAreas as any)[id] ? (this.preServiceAreas as any)[id].name : id
      })).sort((a, b) => a.name.localeCompare(b.name));
    }

    if (this.stationManagerList && this.stationManagerList.length) {
      this.stationManagerList = (_.uniq(this.stationManagerList) as any[]).map(id => ({
        _id: id,
        displayName: (this.preStaffList as any)[id] ? (this.preStaffList as any)[id].displayName : id
      })).sort((a, b) => a.displayName.localeCompare(b.displayName));
    }

    if (this.fundingSourceList && this.fundingSourceList.length) {
      this.fundingSourceList = (_.uniq(this.fundingSourceList) as any[]).map(id => ({
        _id: id,
        displayName: (this.preCorporateUsers as any)[id] ? (this.preCorporateUsers as any)[id].displayName : id
      })).sort((a, b) => a.displayName.localeCompare(b.displayName));
    }

    this.applyFilters();
    this.setDriverCounts();
    this.setBounds();
  }

  getDrivers() {
    this.driverService
      .getDrivers(this.user._id, 'active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preDriverList = (data as any[]).reduce((obj: any, item: any) => {
              obj[item._id] = item;
              return obj;
            }, {});
          }
        },
        (err) => {
          sweetAlert('Error', err, 'warning', 'OK');
        }
      );
  }

  applyFilters() {
    this.filteredDrivers = this.drivers.filter(driver => {
      let isStationManagersExist = true;
      let isServiceAreasExist = true;
      let isFundingSourcesExist = true;

      if (this.selectedStationManagers && this.selectedStationManagers.length) {
        isStationManagersExist = driver.stationManager &&
          this.selectedStationManagers.includes(driver.stationManager);
      }

      if (this.selectedServiceArea && this.selectedServiceArea.length) {
        isServiceAreasExist = driver.serviceAreas &&
          driver.serviceAreas.some(serviceId => this.selectedServiceArea.includes(serviceId));
      }

      if (this.selectedFundingSources && this.selectedFundingSources.length) {
        isFundingSourcesExist = driver.fundingSources &&
          driver.fundingSources.some(fs => this.selectedFundingSources.includes(fs.name));
      }

      return isStationManagersExist && isServiceAreasExist && isFundingSourcesExist;
    });
  }

  getCorporateUsers() {
    this.corporateService.getCorporateUsers('active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preCorporateUsers = (data as any[]).reduce((obj: any, item: any) => {
              obj[item._id] = item;
              return obj;
            }, {});
          }
        },
        (err) => {
          sweetAlert('Error', err, 'warning', 'OK');
        }
      );
  }

  getStaffList() {
    this.staffService.getStaffList()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preStaffList = (data as any[]).reduce((obj: any, item: any) => {
              obj[item._id] = item;
              return obj;
            }, {});
          }
        },
        (err) => {
          sweetAlert('Error', err, 'warning', 'OK');
        }
      );
  }


  // Socket Events END

  // Utils Methods
  getFloatingValues(point) {
    return parseFloat(point)
  }

  expiringSoonTime(trip) {
    const now = moment.utc(new Date()).local().format();
    const expiringSoonTime = moment(trip.scheduleTime);
    return expiringSoonTime.diff(now, "minutes");
  }

  getNameChars(assign) {
    if (assign && assign.priorityClient && assign.priorityClient.displayName) {
      return assign.priorityClient.displayName
        .toLowerCase()
        .trim()
        .split(" ")[0];
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.companyDriverStatus);
    this.socketService.removeListener(Events.GET_APPROCHING_TRIPS);
    this.socketService.removeListener(Events.GET_COMPANY_DRIVER_STATUS);
    this.socketService.removeListener(Events.SEND_EXPIRE_DISPATCH);
    this.socketService.removeListener(Events.GET_MARKED_TRIPS);
    this.socketService.removeListener(Events.SOON_EXPIRING_TRIPS);
  }

  // =====================================
  // Unused (Now) & May be reuse later
  // Modals
  openDriverInfo(driver) {
    this.selectedDriver = driver;
  }

  hightlightDriver(driver) {
    if (this.selectedMapDriver === driver._id) {
      this.selectedMapDriver = '';
    } else {
      this.selectedMapDriver = driver._id;
    }
  }

  getDriverAddress() {
    if (this.selectedDriver && this.selectedDriver.latitude && this.selectedDriver.longitude) {
      this.getAddress(this.selectedDriver.latitude, this.selectedDriver.longitude);
    }
  }

  getAddress(latitude, longitude) {
    this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
      if (status === 'OK') {
        if (results) {
          this.selectedDriver.address = results[0].formatted_address;
        } else {
          sweetAlert('Alert', 'No Address Found', 'warning', 'Ok')
        }
      } else {
        sweetAlert('Alert', `Geocoder failed due to: ${status}`, 'warning', 'Ok')
      }
    });
  }

  closeDriverAddressWindow(evt) {
    this.selectedDriver = null;
  }

  openTripDetailModal(object) {
    this.assignModalObj = object;
  }

  openDriverTripModal(object) {
    this.driverTripModalObject = object;
  }

  tripAssignedResponse(tripStatus) {
    // if (
    //   tripStatus === "Trip Assigned" ||
    //   tripStatus === "Trip Un Assigned" ||
    //   tripStatus === "All Trips Assigned"
    // ) {
    //   // sweetAlert("Success", tripStatus, "success", "OK");
    // } else if (tripStatus !== null) {
    //   sweetAlert("Error", tripStatus, "error", "OK");
    // }
    this.assignModalObj = null;
  }

  onCloseModal(evt) {
    this.assignModalObj = null;
  }

  getNotificationsList() {
    this.dispatchCenterService
      .getNotifications()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.notifications = data;
        }
      });
  }

  onClickProfile(driver) {
    this.driverDetailProfileModal = driver;
  }


  toggleTraffic() {
    this.isTraffic = !this.isTraffic;
    if (this.isTraffic) {
      this.trafficLayer = new google.maps.TrafficLayer();
      this.trafficLayer.setMap(this.agmMap);
    } else {
      this.trafficLayer.setMap(null);
    }
  }

  toggleCTCTrips() {
    this.isCTCTrips = !this.isCTCTrips;
    this.ctcTime = 0;
    this.fetchCtcTrips();
  }
  fetchCtcTrips() {
    if (this.isCTCTrips && this.ctcTime === 0) {
      this.offeredTripsService
        .getCTCTripsList()
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe(data => {
          if (data) {
            this.ctcTripsList = [];
            data.forEach(i => {
              const tripDate = moment.tz(i.DateOfService, this.timeZone).startOf('day');
              const currentDate = moment.tz(this.timeZone);
              if (tripDate.isSameOrBefore(currentDate.startOf('day'), 'day')) {
                i.class = 'today';
                this.ctcTripsList.push(i);
              } else if (tripDate.isSameOrBefore(currentDate.add(1, 'day').startOf('day'), 'day')) {
                i.class = 'tomorrow';
                this.ctcTripsList.push(i);
              }
            });


          }
        });

    }
  }

  ctcRequest(trip, index) {
    const payload = {
      TriplegId: trip.TripLegId,
    }
    this.offeredTripsService
      .putCTCTripClaim(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          if (data.message === 'Created') {
            this.ctcTripsList.splice(index, 1);
          }
        }
      });
  }

  claimTable(trip, index) {
    if (!trip.StandingOrderDays) {
      sweetAlert(`<div class= 'text-main-danger'>Warning</div>`, 'If you reroute these trips once you have claimed them, your ability to use this feature may be suspended. Are you sure you want to claim these trips?', 'warning', 'Yes', 'No')
        .then((result: any) => {
          if (result.value) {
            this.ctcRequest(trip, index);
          }
        })
    }
    else {
      sweetAlert(`<div> <div class= 'text-main-danger'> You are claiming a standing order trip. By doing so, you are agreeing to take the standing order on all scheduled days which are: ${trip.sDays} </div> <div class= 'text-main'> Leg A: ${trip.PickupTime} - ${trip.PickupAddress}  Leg B: ${trip.PickupTime} - ${trip.DropoffAddress} </div> </div>`, `If you reroute these trips once you have claimed them, your ability to use this feature may be suspended. Are you sure you want to claim these trips?`, 'warning', 'Yes', 'No')
        .then((result: any) => {
          if (result.value) {
            this.ctcRequest(trip, index);
          }
        })
    }
  }

  ctcFilterByDate() {
  }

  openDriverTripDetailModal(id) {
    this.driverTripModalObj = id;
  }

  closeModal(evt) {
    this.driverTripModalObj = null;
  }
  showDriverTripsOnMap(driverId) {
    if (this.selectedDriverForManifest === driverId) {
      this.clearManifestFromMap();
      return;
    }

    this.selectedDriverForManifest = driverId;
    const payload = {
      driverId: driverId,
      scheduleTime: moment().tz(this.timeZone).startOf('day').toISOString(),
      status: 'all',
      isTrack: true
    }

    this.dispatchCenterService.getDriverTrips(payload).subscribe(data => {
      if (data && data.assigns && data.assigns.length) {
        this.driverService.getDriverProfile(driverId).subscribe(driver => {
          const points = [];

          // 1. Add Garage Start Point
          if (driver && driver.startingPointAddress && driver.startingPointAddress.latitude) {
            points.push({
              type: 'GARAGE',
              latitude: driver.startingPointAddress.latitude,
              longitude: driver.startingPointAddress.longitude,
              address: driver.startingPointAddress.address,
              time: null,
              trip: { priorityClient: { displayName: 'Garage' } }
            });
          }

          // 2. Add Pickup and Dropoff Points
          data.assigns.forEach((trip, index) => {
            if (trip.status === 'cancelled' && !trip.job) return;

            points.push({
              type: 'PICKUP',
              latitude: trip.jobOriginLatitude,
              longitude: trip.jobOriginLongitude,
              address: trip.jobOriginAddress,
              time: trip.scheduleTime,
              trip: trip,
              tripIndex: index + 1
            });

            if (trip.status !== 'cancelled') {
              points.push({
                type: 'DROPOFF',
                latitude: trip.jobDestinationLatitude,
                longitude: trip.jobDestinationLongitude,
                address: trip.jobDestinationAddress,
                time: trip.appointmentTime,
                trip: trip,
                tripIndex: index + 2
              });
            }

          });

          // 3. Sort by manual order if exists, otherwise by time
          this.manifestPoints = points.sort((a, b) => {
            if (a.type === 'GARAGE') return -1;
            if (b.type === 'GARAGE') return 1;

            const posA = a.type === 'PICKUP' ? a.trip.pickupOrder : a.type === 'DROPOFF' ? a.trip.dropOffOrder : undefined;
            const posB = b.type === 'PICKUP' ? b.trip.pickupOrder : b.type === 'DROPOFF' ? b.trip.dropOffOrder : undefined;

            if (posA !== undefined && posB !== undefined && posA !== null && posB !== null) {
              return posA - posB;
            }

            return moment(a.time).valueOf() - moment(b.time).valueOf();
          });

          // 4. Build single continuous route
          if (this.manifestPoints.length >= 2) {
            this.manifestRoute = {
              origin: {
                lat: this.getFloatingValues(this.manifestPoints[0].latitude),
                lng: this.getFloatingValues(this.manifestPoints[0].longitude)
              },
              destination: {
                lat: this.getFloatingValues(this.manifestPoints[this.manifestPoints.length - 1].latitude),
                lng: this.getFloatingValues(this.manifestPoints[this.manifestPoints.length - 1].longitude)
              },
              waypoints: this.manifestPoints.slice(1, -1).map(p => ({
                location: {
                  lat: this.getFloatingValues(p.latitude),
                  lng: this.getFloatingValues(p.longitude)
                },
                stopover: true
              }))
            };
          }

          // Build segments for color coding
          this.manifestSegments = [];
          for (let i = 0; i < this.manifestPoints.length - 1; i++) {
            const current = this.manifestPoints[i];
            const next = this.manifestPoints[i + 1];
            const segmentColor = next.type === 'GARAGE' ? '#6366f1' : this.getTripStatusColor(next.trip);
            this.manifestSegments.push({
              origin: {
                lat: this.getFloatingValues(current.latitude),
                lng: this.getFloatingValues(current.longitude)
              },
              destination: {
                lat: this.getFloatingValues(next.latitude),
                lng: this.getFloatingValues(next.longitude)
              },
              color: segmentColor,
              renderOptions: {
                suppressMarkers: true,
                polylineOptions: {
                  strokeColor: segmentColor,
                  strokeWeight: 7,
                  icons: [{
                    icon: {
                      path: 'M -7.5 6.75 L 0 -0.75 L 7.5 6.75 M -7.5 0.75 L 0 -6.75 L 7.5 0.75',
                      scale: 0.3,
                      fillOpacity: 1,
                      fillColor: '#ffffff',
                      strokeColor: '#ffffff',
                      strokeWeight: 1.5
                    },
                    offset: '10%',
                    repeat: '100px'
                  }]
                }
              }
            });
          }

          this.driverManifestTrips = data.assigns;
          this.setBounds();
        });
      } else {
        this.clearManifestFromMap();
        sweetAlert('Info', 'No manifest found for this driver', 'info', 'OK');
      }
    }, err => {
      this.clearManifestFromMap();
      sweetAlert('Error', err, 'error', 'OK');
    });
  }

  clearManifestFromMap() {
    this.driverManifestTrips = [];
    this.selectedDriverForManifest = null;
    this.manifestPoints = [];
    this.manifestRoute = null;
    this.manifestSegments = [];
  }

  getTripStatusColor(trip) {
    if (trip.status === 'cancelled') return '#94a3b8'; // Slate 400
    if (trip.status === 'finished' || trip.jobStatus === 'completed') return '#38bdf8'; // Sky 400
    if (trip.jobStatus === 'started') return '#f87171'; // Red 400
    if (trip.jobStatus === 'arrived') return '#fb923c'; // Orange 400
    if (trip.jobStatus === 'onway') return '#facc15'; // Yellow 400
    if (trip.status === 'offered' || trip.status === 'accepted') return '#4ade80'; // Green 400
    return '#60a5fa'; // Blue 400
  }
}
